import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  catalogGroups,
  groupCheckState,
  LrsCatalogGroup,
  LrsCatalogLeaf,
} from 'src/app/shared/constants/lrs-layer-catalog';

@Component({
  selector: 'app-lrs-layer-tree',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lrs-layer-tree.component.html',
  styleUrls: ['./lrs-layer-tree.component.css'],
})
export class LrsLayerTreeComponent {
  @Input() includeBasemaps = false;
  @Input() visibility: Record<string, boolean> = {};
  @Input() counts: Record<string, number> = {};
  @Input() selectedBaseMap = '';
  @Input() expanded: Record<string, boolean> = {};
  @Input() collapseGroupsByDefault = false;

  @Output() visibilityChange = new EventEmitter<{ nodeId: string; checked: boolean }>();
  @Output() baseMapChange = new EventEmitter<string>();
  @Output() expandedChange = new EventEmitter<Record<string, boolean>>();

  get groups(): LrsCatalogGroup[] {
    return catalogGroups(this.includeBasemaps);
  }

  isExpanded(id: string): boolean {
    if (Object.prototype.hasOwnProperty.call(this.expanded, id)) {
      return !!this.expanded[id];
    }
    return !this.collapseGroupsByDefault;
  }

  toggleExpanded(id: string): void {
    const next = { ...this.expanded, [id]: !this.isExpanded(id) };
    this.expandedChange.emit(next);
  }

  leafOn(leaf: LrsCatalogLeaf): boolean {
    if (leaf.source === 'stub') return false;
    return this.visibility[leaf.id] !== false;
  }

  groupState(group: LrsCatalogGroup): 'all' | 'some' | 'none' {
    return groupCheckState(group, this.visibility);
  }

  toggleGroup(group: LrsCatalogGroup, checked: boolean, ev?: Event): void {
    ev?.stopPropagation();
    this.visibilityChange.emit({ nodeId: group.id, checked });
  }

  toggleLeaf(leaf: LrsCatalogLeaf, checked: boolean, ev?: Event): void {
    ev?.stopPropagation();
    if (leaf.source === 'stub') return;
    if (leaf.source === 'basemap') {
      if (leaf.basemapKey) this.baseMapChange.emit(leaf.basemapKey);
      return;
    }
    this.visibilityChange.emit({ nodeId: leaf.id, checked });
  }

  pickBasemap(leaf: LrsCatalogLeaf): void {
    if (leaf.basemapKey) this.baseMapChange.emit(leaf.basemapKey);
  }

  count(leaf: LrsCatalogLeaf): number | null {
    if (leaf.source === 'basemap') return null;
    return this.counts[leaf.id] ?? 0;
  }
}
